<template>
  <section id="ecommerce-header">
    <div class="row">
      <div class="col-sm-12">
        <div class="ecommerce-header-items">
          <div class="result-toggler">
            <feather-icon
              icon="MenuIcon"
              class="d-block d-lg-none"
              size="21"
              @click="$emit('ShowLeftSidebar')"
            />
            <div class="search-results">
              <!-- {{ shopProducts.length + shopProductsPackage.length }} resultado(s) -->
              {{ shopProductsPackage.length }} resultado(s)
            </div>
          </div>

          <div class="view-options d-flex">
            <!-- Opciones de contenido -->
            <b-dropdown
              text="Agenda disponible"
              variant="primary"
              right
              class="mr-75"
            >
              <!-- Ciclo escolar -->
              <b-dropdown-group header="Ciclo escolar">
                <b-dropdown-item
                  v-for="ciclo in cicloEscolar"
                  :key="ciclo.id"
                  @click="filters.ciclo = ciclo; $emit('loadShopItems');"
                >
                  {{ timestampToDate(ciclo.fecha_ini, 'MMMM YYYY') +' - '+ timestampToDate(ciclo.fecha_fin, 'MMMM YYYY') }}
                </b-dropdown-item>
              </b-dropdown-group>

              <b-dropdown-divider />

              <!-- Tipo de contenido -->
              <b-dropdown-group header="Tipo de contenido">
                <b-dropdown-item
                  v-for="type in contentType"
                  :key="type.value"
                  @click="filters.contenido = type"
                >
                  {{ type.text }}
                </b-dropdown-item>
              </b-dropdown-group>
            </b-dropdown>

            <!-- Style view -->
            <b-button-group>
              <b-button
                v-for="(view, index) in itemViewOptions"
                :key="index"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                class="btn-icon"
                :disabled="itemView == view.value"
                @click="$emit('changeViewStyle', view.value)"
              >
                <feather-icon :icon="view.icon" />
              </b-button>
            </b-button-group>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BDropdownGroup,
  BDropdownDivider,
  BButton,
  BButtonGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { nombreModalidad, timestampToDate } from '@core/utils/filter'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownGroup,
    BDropdownDivider,
    BButton,
    BButtonGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    cicloEscolar: {
      type: Array,
      required: true,
    },
    shopProductsPackage: {
      type: Array,
      required: true,
    },
    shopProducts: {
      type: Array,
      required: true,
    },
    itemView: {
      type: String,
      default: 'grid-view',
    },
  },
  data() {
    return {
      nombreModalidad,
      timestampToDate,
      contentType: [
        { text: 'Materias', value: 1 },
      ],
      itemViewOptions: [
        { icon: 'GridIcon', value: 'grid-view' },
        { icon: 'ListIcon', value: 'list-view' },
      ],
    }
  },
  computed: {
    cartItems() {
      return this.$store.state.eCommerce.cartItems
    },
  },
}
</script>
